const ProductRecommendedPosition = {
  EVERYWHERE: 'EVERYWHERE',
  CATEGORY: 'CATEGORY',
  FRONTPAGE: 'FRONTPAGE'
};

export default ProductRecommendedPosition;



// WEBPACK FOOTER //
// ./src/types/ProductRecommendedPosition.js